const modal = document.querySelectorAll('.modal');
const modalBtn = document.querySelectorAll('.modal-open');
const modalClose = document.querySelectorAll('.modal-close');
const iframe = document.querySelector('iframe');

if(modal.length > 0) {
    modalBtn.forEach(function (btn) {
        btn.addEventListener('click', function() {
            modal.forEach(function(mod) {
                if(mod.getAttribute('data-modal') == btn.getAttribute('data-target')) {
                    mod.style.display = 'block';
                }
            });
        });
    });
    modalClose.forEach(function(closeBtn) {
        closeBtn.addEventListener('click', function() {
            modal.forEach(function(mod) {
                mod.style.display = 'none';
            });
            if ( iframe !== null ) {
                let iframeSrc = iframe.src;
                iframe.src = iframeSrc;
            }
        });
    });
    window.addEventListener('click', function(event) {
        modal.forEach(function(mod) {
            if (event.target == mod) {
                mod.style.display = 'none';
            }
            if ( iframe !== null ) {
                let iframeSrc = iframe.src;
                iframe.src = iframeSrc;
            }
        });
    });
}

